import Dialog from '@material-ui/core/Dialog'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect } from 'react'

import { logger } from 'utils/logger'

import * as DialogStyles from './styles'

const useStyles = makeStyles({
    root: {
        borderRadius: 10,
        marginTop: '-5%',
    },
    paperScrollPaper: {
        borderRadius: 10,
        marginTop: '-5%',
    },
})

export default function ReconnectingNotification({ open }) {
    const classes = useStyles()
    console.count('ReconnectingNotification Component')

    useEffect(() => {
        open && logger.info('Room reconnecting...')
    }, [open])

    return (
        <Dialog
            open={open}
            classes={{ paperScrollPaper: classes.paperScrollPaper }}
        >
            <DialogStyles.Container>
                <DialogStyles.Heading>
                    hang in there! reconnecting...
                </DialogStyles.Heading>
                <DialogStyles.PacManContainer>
                    <DialogStyles.PacMan>
                        <DialogStyles.PacManMouth />
                        <DialogStyles.PacManFoodStart />
                        <DialogStyles.PacManFoodMiddle />
                        <DialogStyles.PacManFoodEnd />
                    </DialogStyles.PacMan>
                </DialogStyles.PacManContainer>
            </DialogStyles.Container>
        </Dialog>
    )
}
